// AppGate — gating wrapper that renders the correct screen based on lock state.
// Sits between AppLockProvider and the App shell.

import App from './App';
import { useAppLock, WelcomeScreen, SetupScreen, LockScreen } from './components/AppLock';
import { Loader2 } from 'lucide-react';

export function AppGate() {
  const { isUnlocked, isConfigured, lock, isEnabled, decision, skipEncryption, enableEncryption } =
    useAppLock();

  if (decision === 'pending') {
    return <WelcomeScreen onEnable={enableEncryption} onSkip={skipEncryption} />;
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return;
          await lock.setup(password);
        }}
        onSkip={skipEncryption}
      />
    );
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false;
          return lock.unlock(password);
        }}
      />
    );
  }

  if (!isUnlocked) {
    return (
      <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-bg)' }}>
        <Loader2
          size={32}
          className="animate-spin"
          style={{ color: 'var(--color-accent)' }}
          aria-label="Loading"
        />
      </div>
    );
  }

  return <App />;
}
